export default __webpack_public_path__ + "static/media/diners.406d1c2a.svg";